<template>
  <div class="basic_wrap">
<!--    <img class="logo" src="../images/logo/logo.png" alt="" @click="$router.push('/')" />-->

    <form class="form">
      <div class="item mt">
        <span class="icon">
          <img src="../images/login/phone_a.png" alt="" />
        </span>
        <span class="re-phone">+55</span>
        <input v-model.trim="data.mobile" type="text" class="inp" :placeholder="$t('请输入您的手机号')" />
      </div>
      <!--            验证码-->
      <!-- <div v-if="show_sms > 0" class="item mt">
        <span class="icon" style="margin-left: 4px">
          <img src="../images/login/email.png" alt="" />
        </span>
        <input v-model.trim="data.sms" type="text" class="inp" :placeholder="$t('短信验证码')" />
        <van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
          <span @click="sendcode" style="font-size: 0.35rem">{{
            showTime > 0 ? showTime : $t("发送")
          }}</span>
        </van-count-down>
      </div> -->
      <!--            密码-->
      <div class="item mt">
        <span class="icon"><img src="../images/login/pwd_a.png" alt="" /></span>
        <input v-model.trim="data.password" :type="password" class="inp" :placeholder="$t('请设置登录密码')" />
        <div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd"></div>
      </div>
      <!--  重复密码-->
      <div class="item mt">
        <span class="icon"><img src="../images/login/pwd_a.png" alt="" /></span>
        <input v-model.trim="data.spassword" :type="password" class="inp" :placeholder="$t('重复登录密码')" />
        <div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd"></div>
      </div>
      <!--            邀请码-->
      <!-- <div class="item mt">
        <span class="icon">
          <img src="../images/team.png" alt="" style="height: 16px" />
        </span>
        <input
          type="text"
          class="inp"
          disabled
          v-model.trim="data.invitation_code"
          :placeholder="$t('register.invitation')"
        />
      </div> -->

      <div class="basic_btn sbtn" :class="data.mobile == '' ||
        data.code == '' ||
        data.password == '' ||
        data.spassword != data.password
        ? 'no_touch'
        : ''
        " @click="submit">
        {{ $t("立即注册") }}
      </div>
      <p class="tips">
        {{ $t("已有账号?") }}?
        <span class="signup" @click="$router.push('/login')">{{
          $t("立即登录")
        }}</span>
      </p>

    </form>

    <van-dialog v-model="statement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
      @click="privacyStatementHide">
    </van-dialog>
    <van-dialog v-model="agreement" confirm-button-color="#fb661e" :close-on-click-overlay="true" @click="agreementHider">
    </van-dialog>

    <!--        <div v-if="msg_show" class="kefu" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">-->
    <!--            <img class="kefu_img" src="../images/index/kefu.png">-->
    <!--        </div>-->

    <!-- <van-loading type="spinner" v-show="loading_flag" /> -->
  </div>
</template>

<script>
import Vue from "vue";

import { CountDown, Checkbox, Dialog, Loading } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(CountDown).use(Checkbox).use(Dialog).use(Loading);

export default {
  name: "Register",
  data() {
    return {
      showTime: 0,
      timeId: null,
      time: 0,
      agreement: false,
      statement: false,
      show_kefu: false,
      msg_show: true,
      show_sms: 1,
      password: "password",
      data: {
        password: "",
        spassword: "",
        mobile: "",
        invitation_code: localStorage.getItem("code") || null,
        sms: "",
      },
      showIn: true,
      config: {},
      loading_flag: true,
    };
  },
  created() {
    this.$parent.footer("user", true);

  },
  mounted() {

    let code = this.$route.query.code;
    //console.log(code);
    if (code) {
      // localStorage.setItem('code', code);
      // console.log(code);
      this.data.invitation_code = code;
    } else {
      console.log(window.location.href);
      let idx = window.location.href.indexOf("code%3D");
      console.log(idx);
      let url_code = "";
      if (idx != -1) {
        url_code = window.location.href.substring(idx + 7, idx + 13)
        console.log(url_code);
      }
      if (url_code) {
        this.data.invitation_code = url_code;
      }
    }

    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );

    this.loading_flag = true;

    Fetch("/sms/getRecentCode", { event: "register" }, false, false).then((res) => {
      //console.log(res);
      if (res.data) {
        this.data.mobile = res.data.mobile;
        this.loading_flag = false;
        this.is_send = true;
        let leftTime = 120 - (Date.parse(new Date()) / 1000 - res.data.createtime);
        //console.log(Date.parse(new Date()) / 1000, res.data.createtime);
        //console.log(leftTime);
        this.time = leftTime * 1000;
        this.showTime = leftTime;
        this.timeId = setInterval(() => {
          this.showTime--;
        }, 1000);
      }

      // if (res.ip.region) {
      //     if (res.ip.region.indexOf("印度") != -1) {
      //         this.data.mobile = "+91";
      //     }
      //     else if (res.ip.region.indexOf("墨西哥") != -1) {
      //         this.data.mobile = "+52";
      //     } else {
      //         this.data.mobile = "+1";
      //     }
      // }
      // else {
      //     this.data.mobile = "+1";
      // }
    });
  },
  destroyed() {
    if (this.timeId) clearInterval(this.timeId);
  },
  methods: {

    kefu_to() {
      if (this.show_kefu) {
        this.$router.push("/kefu");
      }
      this.show_kefu = !this.show_kefu;
    },
    showPwd() {
      if (this.password == "password") {
        this.password = "text";
      } else {
        this.password = "password";
      }
    },
    timeCall() {
      this.is_send = false;
      this.time = 0;
      clearInterval(this.timeId);
      //console.log("coundown finished");
    },
    sendcode() {
      if (this.is_send) {
        return;
      }

      if (!this.data.mobile || this.data.mobile.length <= 9) {
        this.$toast(this.$t("请输入您的手机号"));
        return;
      }
      //console.log(this.data.mobile);return;
      this.is_send = true;
      Fetch("/sms/send", {
        mobile: this.data.mobile,
        event: 'register',
      })
        .then((res) => {
          if (res.code == 1) {
            this.time = 120 * 1000;
            this.showTime = 120;
            this.timeId = setInterval(() => {
              this.showTime--;
            }, 1000);
            // console.log(res);
            this.$toast({
              background: "#07c160",
              message: this.$t("发送成功"),
            });
          } else {
            this.$toast({
              background: "#07c160",
              message: res.msg,
            });
            this.is_send = false;
          }

        })
        .catch(() => {
          this.is_send = false;
        });
    },
    submit() {
      if (!this.data.mobile) {
        this.$toast({
          type: "fail",
          icon: require("../images/common/angry.png"),
          background: "#07c160",
          message: this.$t("手机号码不能为空"),
          duration: 10000,
        });
        return false;
      }
      if (!this.data.password) {
        this.$toast({
          type: "fail",
          icon: require("../images/common/angry.png"),
          background: "#07c160",
          message: this.$t("密码长度为6-18位"),
          duration: 3000,
        });
        return false;
      }

      if (this.data.password.length < 6) {
        this.$toast({
          type: "fail",
          icon: require("../images/common/angry.png"),
          background: "#07c160",
          message: this.$t("密码长度为6-18位"),
          duration: 3000,
        });
        return false;
      }

      if (this.data.password != this.data.spassword) {
        this.$toast({
          type: "fail",
          icon: require("../images/common/angry.png"),
          background: "#07c160",
          message: this.$t("两次密码不一致"),
          duration: 3000,
        });
        return false;
      }

      //判断邀请码是否有
      // if (!this.data.invitation_code) {
      //     this.$toast(this.$t('register.invitation_must'));
      //     return false;
      // }

      //console.log(this.data);

      this.data.mobile = this.data.mobile.replace(new RegExp("[+]", "gm"), "");
      Fetch("/user/register", this.data)
        .then((res) => {
          //console.log(res);
          if (res.code == 1) {
            //注册成功
            this.$toast({
              type: "success",
              icon: require("../images/common/laugh.png"),
              background: "#07c160",
              message: this.$t("注册成功"),
              duration: 3000,
            });
            localStorage.setItem("login_username", this.data.mobile);

            setTimeout(() => {
              // this.$router.push("/login");
              window.location.href = "/#/login";
            }, 3000);
          } else {
            //注册失败了
            this.$toast({
              type: "fail",
              icon: require("../images/common/angry.png"),
              background: "#07c160",
              message: res.msg,
              duration: 3000,
            });
          }
        })
        .catch((e) => {
          //请求发生了错误
          this.$toast({
            type: "fail",
            icon: require("../images/common/angry.png"),
            background: "#07c160",
            message: this.$t("系统繁忙,请稍后再尝试"),
            duration: 3000,
          });
          return false;
        });
    },
    userAgreement() {
      this.agreement = true;
    },
    agreementHider() {
      this.agreement = false;
    },
    privacyStatement() {
      this.statement = true;
    },
    privacyStatementHide() {
      this.statement = false;
    },
  },
};
</script>

<style lang="less" scoped>
.re-phone {
  color: #ffffff;
  font-weight: 700;
  display: inline-block;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  margin-left: 5px;
}

.big_tit {
  position: absolute;
  height: 25px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
}

.lgbg {
  position: absolute;
  left: 5%;
  top: 20%;
  width: 90%;
  height: 80%;
}

.login_bg {
  width: 100%;
  height: 220px;
  overflow: hidden;
  background: url("../images/login.png");
  background-position: center;
  background-size: 100% 100%;
  position: relative;
}

.basic_wrap {
  // position: fixed;
  width: 100%;
  min-height: 100vh;
  background: url("../images/login/login_bg_a.png") no-repeat;
  background-size: 100%;
}

.basic_wrap .form {


  margin: 15px auto 0 auto;
  width: 92%;
  height: 40%;
  background: #0e4114a3;
  border-radius: 13px;
  padding: 12px 12px 0 12px;
  margin-top: 40vh;
}

.cut_login {
  line-height: 25px;
  align-items: center;
  justify-content: center;
  font-size: 0.5rem;
  font-weight: 700;
  text-align: left;
  margin: 0 auto;
  color: white;
}

.block {
  width: 100%;
  height: 100%;
  // overflow:hidden;
  // margin: 10% auto;
  font-size: 15px;
  justify-content: center;
  background-color: #fff;
  border-radius: 5px;

  .block-title {
    display: block;
    font-weight: bolder;
    line-height: 39px;
    height: 39px;
    text-align: center;
  }

  .p_agr {
    // padding-top:30rpx;
    font-size: 12px;
    /*font-weight: bolder;*/
    line-height: 20px;
    padding: 0px 10px;
    height: 388px;
    /*overflow: hidden;*/
    // overflow: auto;
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
  }

  .div_qd {
    width: 60px;
    height: 25px;

    span {
      width: 60px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      justify-content: center;
      background: #fb661e;
      border-radius: 10px;
      padding: 1px 5px;
      color: #fff;
    }

    margin: 10px auto;
  }
}

.mt {
  margin-top: 10px;
}

.item {
  height: 30px;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 8px;
  box-sizing: content-box;
  //border: 1px solid red;
  background: #287537ad;
  border-radius: 8px;

  .icon {
    width: 28px;
    height: 25px;

    .people {
      width: 23px;
      height: 20px;
    }

    img {
      display: block;
      margin: 0 auto;
      width: 17px;
      height: 20px;
    }
  }

  input {
    height: 25px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
    color: #FFFFFF;
    //font-weight: 700;
    font-size: 0.4rem;
  }
}

.get_captcha {
  // width: 120px;
  height: 27px;
  border-left: 0.5px solid #4d5d93;
  text-align: center;
  // line-height: 27px;
  font-size: 14px;
  background: linear-gradient(rgb(204, 69, 253), rgb(64, 5, 166));
  color: #fff;
  padding: 4px 10px;
  border-radius: 3px;
  // color: rgb(222, 91, 137);
}

.protocol {
  font-size: 12px;
  line-height: 17px;
  margin-top: 20px;
  color: #999999;

  a {
    color: #3d96ff;
  }
}

.basic_btn {
  margin: 25px auto 0 auto;
  color: #073F22 ;
  height: 40px;
  line-height: 40px;
  width: 95%;
  font-weight: 700;
  background: url("../images/login/submit.png") no-repeat;
  background-size: 100%;
}

.tips {
  height: 30px;
  line-height: 30px;
  color: #ffffff;
  margin-top: 8px;
  text-align: center;
  margin-top:20px;
  font-size: 15px;
}

.signup {
  font-weight: 700;
  font-size: 0.35rem;
  color: #FEEA02;
}
::placeholder {
  color: white;
}
</style>
